(function(){
  var params=new URLSearchParams(window.location.search);
  var sub1=params.get('sub1')||params.get('adname')||sessionStorage.getItem('_sub1')||'';
  var sub2=params.get('sub2')||params.get('fbclid')||sessionStorage.getItem('_sub2')||'';
  if(sub1)sessionStorage.setItem('_sub1',sub1);
  if(sub2)sessionStorage.setItem('_sub2',sub2);
  var base='https://superboostnutra.com/products/creatine-boost';
  var greensBase='https://superboostnutra.com/products/super-greens';
  function trackingUrl(u){var url=u||base,sep='?';if(sub1){url+=sep+'sub1='+encodeURIComponent(sub1);sep='&'}if(sub2)url+=sep+'sub2='+encodeURIComponent(sub2);return url}
  function linkify(pattern,url,cls){
	var scopes=document.querySelectorAll('.article p:not(.exempt), .article .benefit p, .wide-band-copy p, .milestone p, .results h2, .result-card p, .caption span, .product-copy p, .faq p, .faq summary');
	var skip=/^(A|SCRIPT|STYLE|CODE)$/;
	scopes.forEach(function(el){
	  if(el.closest('.sources')||el.closest('.nav'))return;
	  var walker=document.createTreeWalker(el,NodeFilter.SHOW_TEXT,{acceptNode:function(n){
		if(!pattern.test(n.nodeValue))return NodeFilter.FILTER_REJECT;
		var p=n.parentNode;while(p&&p!==el){if(skip.test(p.nodeName))return NodeFilter.FILTER_REJECT;p=p.parentNode}
		return NodeFilter.FILTER_ACCEPT}},false);
	  var nodes=[],n;while(n=walker.nextNode())nodes.push(n);
	  nodes.forEach(function(node){
		var frag=document.createDocumentFragment(),text=node.nodeValue,re=new RegExp(pattern.source,'gi'),last=0,m;
		while(m=re.exec(text)){
		  if(m.index>last)frag.appendChild(document.createTextNode(text.slice(last,m.index)));
		  var a=document.createElement('a');
		  a.className=cls+' inline-link';a.href=trackingUrl(url);a.textContent=m[0];
		  frag.appendChild(a);last=m.index+m[0].length;
		}
		if(last<text.length)frag.appendChild(document.createTextNode(text.slice(last)));
		node.parentNode.replaceChild(frag,node);
	  });
	});
  }
  function update(){
	document.querySelectorAll('.product-link').forEach(function(l){l.href=trackingUrl(base)});
	document.querySelectorAll('.greens-link').forEach(function(l){l.href=trackingUrl(greensBase)});
  }
  function init(){linkify(/creatine/i,base,'product-link');linkify(/greens?/i,greensBase,'greens-link');update()}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();
